import { sprintf } from '@wordpress/i18n'
import _ from 'lodash'
import { getCurrentLangWithAttribute } from '../../react/helpers.js'
import { _k, _kn } from '../languages/language.js'
import noUiSlider from 'nouislider'
import wNumb from 'wnumb'

export default class ProductFilters {
    constructor() {
        // Set class variables
        this.currLang = getCurrentLangWithAttribute()
        this.filtersEl = document.getElementById('kpc-filters')
        this.filtersFormEl = document.querySelector('#kpc-filters form')
        this.filtersListEl = document.getElementById('kpc-filters-list')

        this.filtersBarEl = document.getElementById('kpc-filters-bar')
        this.filtersBtnShowEl = document.getElementById('kpc-filters-button-show')
        this.filtersBtnCloseEl = document.getElementById('kpc-filters-close')
        this.filtersBtnClearEl = document.getElementById('kpc-filters-button-clear')

        this.filtersValue = {}

        this.getRequestParams()
        this.displayFiltersList()
        this.filtersButtons()
        if (!!this.filtersBarEl) this.filtersBar()

        // Display product count
        this.filtersFormEl.addEventListener('input', () => {
            this.displayProductCount()
        })
    }

    getRequestParams() {
        let reqParams = {}

        // Create a link parser
        let linkParser = document.createElement('a')
        linkParser.href = window.location.href // Pass current url to parser

        // Get query string (string with all params)
        let query = linkParser.search.substring(1),
            strParams = query.split('&')

        for (let strParam of strParams) {
            let [key, value] = strParam.split('=')

            // decode param
            key = decodeURI(key)
            value = decodeURI(value)

            // filter params
            if (!_.startsWith(key, 'pf_')) continue

            if (key.indexOf('[]')) {
                key = key.replace('[]', '')

                if (_.isEmpty(reqParams[key])) {
                    reqParams[key] = []
                }

                reqParams[key].push(decodeURIComponent(value))
            } else {
                reqParams[key] = decodeURIComponent(value)
            }
        }

        this.filtersValue = reqParams
    }

    async displayFiltersList() {
        let html = '',
            atList = null

        try {
            // Get attributes list
            atList = await this.getAttributesList()
        } catch (e) {
            console.error(e)
            return false
        }

        if (!_.isEmpty(atList)) {
            _.forEach(atList, (at, atKey) => {
                switch (at.type) {
                    case 'TEXT':
                        html += this.displayTextAttribute(at)
                        break
                    case 'NUMBER':
                        html += this.displayNumberAttribute(at)
                        break
                    case 'BOOLEAN':
                        html += this.displayBooleanAttribute(at)
                        break
                    case 'SIMPLE_SELECT':
                    case 'SELECT_MULTIPLE':
                        html += this.displaySelectAttribute(at)
                        break
                }
            })
        } else {
            this.filtersEl.classList.toggle('kpc-no-filters')
            if (!_.isEmpty(this.filtersBtnShowEl))
                this.filtersBtnShowEl.classList.toggle('kpc-no-filters')
        }

        this.filtersListEl.innerHTML = html

        this.postRender(atList)
    }

    displayTextAttribute(at) {
        let html = ''

        let attrID = 'pf_' + at.id

        let value = !_.isEmpty(this.filtersValue[attrID]) ? this.filtersValue[attrID] : ''

        html += `
        <div class="kpc-filter-group">
        <label for="${attrID}" class="kpc-filter-label">${at.label[this.currLang]}</label>
        <input
        type="text"
        id="${attrID}"
        name="${attrID}"
        class="kpc-filter-input"
        ${!_.isEmpty(value) ? 'value="' + value + '"' : ''}
        />
        </div>
        `

        return html
    }

    displayNumberAttribute(at) {
        let html = ''

        let attrID = 'pf_' + at.id

        // Get values
        let values = {
            min: !_.isNil(this.filtersValue[attrID + '_min'])
                ? this.filtersValue[attrID + '_min']
                : null,
            max: !_.isNil(this.filtersValue[attrID + '_max'])
                ? this.filtersValue[attrID + '_max']
                : null,
        }

        // filter params
        let range_min = false,
            range_max = false

        if (!_.isNil(at.parameters.num_min)) {
            range_min = at.parameters.num_min
        }
        if (!_.isNil(at.parameters.num_max)) {
            range_max = at.parameters.num_max
        }

        html += `
        <div class="kpc-filter-group">
        <label for="${attrID}" class="kpc-filter-label">${at.label[this.currLang]}</label>
        <div
        id="${attrID}"
        class="kpc-filter-range-slider"
        data-input-name="${attrID}"
        data-range-min="${range_min !== false ? range_min : ''}"
        data-range-max="${range_max !== false ? range_max : ''}"
        ></div>
        <input
        type="hidden"
        name="${attrID}_min"
        value="${!_.isNil(values.min) ? values.min : ''}"
        />
        <input
        type="hidden"
        name="${attrID}_max"
        value="${!_.isNil(values.max) ? values.max : ''}"
        />
        </div>
        `

        return html
    }

    displayBooleanAttribute(at) {
        let html = ''

        let attrID = 'pf_' + at.id

        let value = !_.isEmpty(this.filtersValue[attrID]) ? this.filtersValue[attrID] : ''

        html += `
        <div class="kpc-filter-group">
        <label for="${attrID}" class="kpc-filter-label">${at.label[this.currLang]}</label>
        <div class="kpc-filter-check">
        <input
        class="kpc-filter-check-input"
        type="radio"
        value="yes"
        id="${attrID}-yes"
        name="${attrID}"
        ${value == 'yes' ? 'checked' : ''}
        >
        <label class="kpc-filter-check-label" for="${attrID}-yes">
        ${_k('Yes', this.currLang)}
        </label>
        </div>
        <div class="kpc-filter-check">
        <input
        class="kpc-filter-check-input"
        type="radio"
        value="no"
        id="${attrID}-no"
        name="${attrID}"
        ${value == 'no' ? 'checked' : ''}
        >
        <label class="kpc-filter-check-label" for="${attrID}-no">
        ${_k('No', this.currLang)}
        </label>
        </div>
        <div class="kpc-filter-check">
        <input
        class="kpc-filter-check-input"
        type="radio"
        value=""
        id="${attrID}-all"
        name="${attrID}"
        ${value == '' ? 'checked' : ''}
        >
        <label class="kpc-filter-check-label" for="${attrID}-all">
        ${_k('All', this.currLang)}
        </label>
        </div>
        </div>
        `

        return html
    }

    isInteger(value) {
        return /^\d+$/.test(value)
    }

    displaySelectAttribute(at) {
        let html = ''

        let attrID = 'pf_' + at.id

        // Get filter values
        let values = !_.isEmpty(this.filtersValue[attrID]) ? this.filtersValue[attrID] : []
        if (!_.isArray(values)) {
            values = [values]
        }

        // Build options list
        let optionsHtml = ''

        if (_.isArray(at.options) && at.options.length > 0) {
            // Order Options by Label in Current language
            let orderOptions = _.sortBy(at.options, (o) => {
                if (this.isInteger(o.label[this.currLang]))
                    return parseInt(o.label[this.currLang], 10)
                // Order Int
                else return o.label[this.currLang] // Order Text
            })

            // Create html
            for (let atOpt of orderOptions) {
                let optID = attrID + '_' + atOpt.code

                optionsHtml += `
                <div class="kpc-filter-check">
                <input
                class="kpc-filter-check-input"
                type="checkbox"
                value="${atOpt.code}"
                id="${optID}"
                name="${attrID}[]"
                ${values.includes(atOpt.code) ? 'checked' : ''}
                >
                <label class="kpc-filter-check-label" for="${optID}">
                ${atOpt.label[this.currLang]}
                </label>
                </div>
                `
            }
        }

        html += `
        <div class="kpc-filter-group">
        <label class="kpc-filter-label">${at.label[this.currLang]}</label>
        ${optionsHtml}
        </div>
        `

        return html
    }

    postRender(atList) {
        if (!_.isEmpty(atList)) {
            _.forEach(atList, (at, atKey) => {
                switch (at.type) {
                    case 'NUMBER':
                        this.registerNumberAttribute(at)
                        break
                }
            })
        }

        this.displayProductCount()
    }

    registerNumberAttribute(at) {
        let attrID = 'pf_' + at.id,
            sliderEl = document.getElementById(attrID),
            inputMinEl = document.querySelector(`input[name="${attrID}_min"]`),
            inputMaxEl = document.querySelector(`input[name="${attrID}_max"]`),
            sliderRangeOpt = {
                min: at.parameters.num_min || 0,
                max: at.parameters.num_max || 100,
            }

        let rangeVal = [
            !_.isEmpty(inputMinEl.value) ? inputMinEl.value : sliderRangeOpt.min,
            !_.isEmpty(inputMaxEl.value) ? inputMaxEl.value : sliderRangeOpt.max,
        ]

        noUiSlider.create(sliderEl, {
            start: rangeVal,
            connect: true,
            range: sliderRangeOpt,
            tooltips: [true, true],
            step: 1,
            format: wNumb({
                decimals: 0,
            }),
        })

        sliderEl.noUiSlider.on('change', (values) => {
            inputMinEl.value = values[0]
            inputMaxEl.value = values[1]
        })
    }

    getTermId() {
        return parseInt(this.filtersEl.dataset.termId)
    }

    getAttributesList() {
        return new Promise((resolve, reject) => {
            // Get the category id
            let termId = this.getTermId()

            // Prepare URL
            let apiUrl = new URL(kpc_loc.endpoint + '/filters/list'),
                searchParams = new URLSearchParams({})

            if (_.isInteger(termId)) {
                searchParams.append('termId', termId)
            }

            if (!_.isEmpty(this.currLang)) {
                searchParams.append('lang', this.currLang)
            }

            if (!_.isEmpty(this.filtersValue)) {
                _.each(this.filtersValue, (f_val, f_key) => {
                    if (_.isArray(f_val)) {
                        _.each(f_val, (v) => {
                            searchParams.append(`${f_key}[]`, v)
                        })
                    } else {
                        searchParams.append(f_key, f_val)
                    }
                })
            }

            apiUrl.search = searchParams.toString()

            fetch(apiUrl, {
                method: 'GET',
                // headers: headers,
                mode: 'cors',
                cache: 'default',
            })
                .then((response) => {
                    return response.json()
                })
                .then((result) => {
                    if (result.status == 'DONE') {
                        resolve(result.data)
                    } else {
                        reject(result.status)
                    }
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    resetFilters() {
        let currUrl = window.location.href,
            newUrl = '',
            paramsRegex = /pf_[^=]*=[^&]*/gi,
            consAndRegex = /(&)\1+/gi

        // Remove params from url
        newUrl = currUrl.replaceAll(paramsRegex, '')

        // Remove consecutive '&' from url
        newUrl = newUrl.replaceAll(consAndRegex, '&')

        // Remove '&' just after '?'
        newUrl = newUrl.replaceAll('?&', '?')

        // Remove '&' at end of url
        newUrl = _.trimEnd(newUrl, '&')

        // Remove '?' at end of url
        newUrl = _.trimEnd(newUrl, '?')

        if (currUrl != newUrl) {
            window.location.href = newUrl
        }
    }

    filtersButtons() {
        let btnEl = document.getElementById('kpc-filters-reset')
        btnEl.addEventListener('click', () => {
            this.resetFilters()
        })
    }

    filtersBar() {
        // Panel Open / Close
        this.filtersBtnShowEl.addEventListener('click', (event) => {
            this.filtersEl.classList.toggle('kpc-show')
        })

        this.filtersBtnCloseEl.addEventListener('click', (event) => {
            this.filtersEl.classList.toggle('kpc-show')
        })

        if (!_.isEmpty(this.filtersValue)) {
            this.filtersBtnClearEl.classList.add('kpc-show')
            this.filtersBtnClearEl.addEventListener('click', (event) => {
                this.resetFilters()
            })
        }
    }

    getProductsCount() {
        return new Promise((resolve, reject) => {
            // Get the category id
            let termId = this.getTermId()

            // Get filters value from form
            let formData = new FormData(this.filtersFormEl),
                formValues = {}

            formData.forEach((f_val, f_key) => {
                if (f_key.indexOf('[]')) {
                    f_key = f_key.replace('[]', '')

                    if (_.isEmpty(formValues[f_key])) {
                        formValues[f_key] = []
                    }

                    formValues[f_key].push(f_val)
                } else {
                    formValues[f_key] = f_val
                }
            })

            // Prepare URL
            let apiUrl = new URL(kpc_loc.endpoint + '/filters/products-count'),
                searchParams = new URLSearchParams({})

            if (_.isInteger(termId)) {
                searchParams.append('termId', termId)
            }

            if (!_.isEmpty(formValues)) {
                _.each(formValues, (f_val, f_key) => {
                    if (_.isArray(f_val)) {
                        _.each(f_val, (v) => {
                            searchParams.append(`${f_key}[]`, v)
                        })
                    } else {
                        searchParams.append(f_key, f_val)
                    }
                })
            }

            apiUrl.search = searchParams.toString()

            fetch(apiUrl, {
                method: 'GET',
                // headers: headers,
                mode: 'cors',
                cache: 'default',
            })
                .then((response) => {
                    return response.json()
                })
                .then((result) => {
                    if (result.status == 'DONE') {
                        resolve(result.data)
                    } else {
                        reject(result.status)
                    }
                })
                .catch((error) => {
                    reject(error)
                })
        })
    }

    async displayProductCount() {
        let prCount = 0,
            countEl = document.getElementById('kpc-filters-product-count'),
            submitBtnEl = document.getElementById('kpc-filters-submit')

        // Get product count
        try {
            prCount = await this.getProductsCount()
        } catch (e) {
            console.error(e)
            return false
        }

        // display submit button if 0 products
        if (prCount > 0) {
            submitBtnEl.disabled = false
        } else {
            submitBtnEl.disabled = true
        }

        // Display count
        countEl.innerHTML = sprintf(
            _kn('%s product', '%s products', prCount, this.currLang),
            prCount
        )
    }
}
